import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import Checkbox from "@mui/material/Checkbox";
import { styled } from '@mui/material/styles';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import EnhancedCheckbox from "./EnhancedCheckbox";

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
    "&.Mui-checked": {
        color: theme.palette.tertiary?.main || theme.palette.primary.main,
    },
    "& .MuiSvgIcon-root": {
        fontSize: "14px",
    },
}));

const UncheckedIcon = styled('span')({
    width: 18,
    height: 18,
    borderRadius: 6,
    border: '1.5px solid #999',
    backgroundColor: 'transparent',
});

const CheckedIcon = styled('span')(({ theme }) => ({
    width: 18,
    height: 18,
    borderRadius: 6,
    border: `1.5px solid ${theme.palette.tertiary?.main || theme.palette.primary.main}`,
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
        fontSize: 14,
        color: theme.palette.tertiary?.main || theme.palette.primary.main,
    },
}));

interface FormHelperCheckboxProps {
    input: {
        name: string;
        value: any;
        onChange: (...args: any[]) => void;
        [key: string]: any;
    };
    meta: {
        submitError?: any;
        dirtySinceLastSubmit?: boolean;
        error?: any;
        touched?: boolean;
    };
    label?: React.ReactNode;
    formControlProps?: any;
    shrink?: boolean;
    [key: string]: any;
}

export const FormHelperEnhancedCheckbox = ({
                                          input: {name, value, onChange, ...restInput},
                                          meta,
                                          label,
                                          formControlProps,
                                          shrink,
                                          ...rest
                                      }: FormHelperCheckboxProps) => {
    const showError = !(!(((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) && meta.touched));

    return (
        <FormControl {...formControlProps} error={showError} style={{flexDirection: "row", alignItems: "center"}}>
            {label &&
                <InputLabel shrink={shrink ? true : undefined} htmlFor={name}
                            style={{
                                position: "relative",
                                transform: "none",
                            }}
                >
                    {label}:
                </InputLabel>
            }

            <EnhancedCheckbox
                {...rest}
                {...restInput}
                checked={value}
                label={label}
                error={showError ? meta.error || meta.submitError : ""}
                onChange={onChange}
            />

            {showError && ((meta.error && meta.error !== true) || (meta.submitError && meta.submitError !== true)) &&
                <FormHelperText>{meta.error || meta.submitError}</FormHelperText>
            }
        </FormControl>
    );
};

interface CatalogCheckboxProps {
    onClick?: (...args: any[]) => void;
    checked?: boolean;
    onChange?: (...args: any[]) => void;
    disabled?: boolean;
    indeterminate?: boolean;
    [key: string]: any;
}

function CatalogCheckbox(props: CatalogCheckboxProps) {
    return (
        <StyledCheckbox color={"default"} onClick={props.onClick}
                  checked={props.checked} onChange={props.onChange} disabled={props.disabled}
                  indeterminate={props.indeterminate}
                  size={"medium"}
                  icon={<UncheckedIcon/>}
                  checkedIcon={<CheckedIcon><CheckIcon/></CheckedIcon>}/>
    );
}

export default CatalogCheckbox;
